var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{dkswitch:true,on:_vm.internalValue,disabled:_vm.disabled},on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"mover"})])}
var staticRenderFns = []

export { render, staticRenderFns }